export default {"src":"/_next/static/media/mediumPriority.ec886ffb.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};